import React, { useMemo } from "react";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import axios from "axios";

import { CustomCheckbox, ProductListContainer } from "../../component/styled";
import { calcPrice, renderImage } from "../../../common/function/shopping";

import { FaMinus, FaPlus } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router";

const ProductList = ({
  data = {},
  openModal,
  closeModal,
  selectionDelete,
  deleteProduct,
  totalProductCount,
  setSelection,
  updateCart,
  setData,
}) => {
  const navigate = useNavigate();

  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const user = useSelector((state) => state?.user?.data[0]);

  const allItems = data.flatMap((company) => company.products);
  const isAllChecked = allItems.length > 0 && allItems.every((item) => item.checked);

  const upsertCart = async (product) => {
    const body = {
      input: {
        id: product.id,
        mberNo: user?.mberNo,
        platform: "MULTI_PAGE",
        vendorProductId: product.vendorProductId,
        quantity: product.quantity,
        checked: product.checked,
        options: product.options.map((opt) => ({
          id: opt.id,
          optionId: opt.optionId,
          qty: opt.qty,
          name: opt.name,
          price: opt.price,
          optionGroupName: opt.optionGroupName,
        })),
      },
    };

    try {
      const res = await axios.post("/erp/cart/upsert", body);
      if (res.status === 200) {
        updateCart(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 수량 변경
  const handleQtyChange = (item, diff) => {
    const newQty = item.quantity + diff;
    if (newQty < 1) return;
    const updated = { ...item, quantity: newQty };
    upsertCart(updated);
  };

  const renderCounter = (item) => {
    return (
      <div className="counter">
        <button onClick={() => handleQtyChange(item, -1)}>
          <FaMinus />
        </button>
        <span>{item.quantity}</span>
        <button onClick={() => handleQtyChange(item, 1)}>
          <FaPlus />
        </button>
      </div>
    );
  };

  const toggleAllCheck = async (checked) => {
    const cartIds = data.flatMap((company) => company.products).map((item) => item.id);
    if (cartIds.length === 0) return;

    try {
      const url = "/erp/cart/checked";
      const body = { cartIds, checked };
      const res = await axios.post(url, body);

      if (res.status === 200) {
        setData((prev) =>
          prev.map((group) => ({
            ...group,
            products: group.products.map((product) => ({
              ...product,
              checked,
            })),
          })),
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const renderAllCheck = () => {
    return (
      <CustomCheckbox>
        <input
          type="checkbox"
          checked={isAllChecked}
          onChange={(e) => toggleAllCheck(e.target.checked)}
        />
        <span></span>
      </CustomCheckbox>
    );
  };

  const navigateProduct = async (item) => {
    const domain = await getDomain(item.cmpnyNo);
    navigate(`/shop/${domain}/productsView/${item.id}`);
  };

  const getDomain = async (cmpnyNo) => {
    const url = "/api/domainSettingLoad";
    const body = { cmpnyNo, delYn: "N" };

    try {
      const res = await axios.post(url, body);
      const domain = res?.data?.domain;
      if (domain) {
        return domain;
      }
    } catch (error) {
      return null;
    }
  };

  return (
    <ProductListContainer>
      {isMobile ? (
        <li className="header">
          <div>
            {renderAllCheck()}
            <span>전체선택</span>
          </div>
          <div>
            <button onClick={() => selectionDelete(true)}>장바구니 비우기</button>
            <button onClick={() => selectionDelete()}>선택상품 삭제</button>
          </div>
        </li>
      ) : (
        totalProductCount > 0 && (
          <li className="header">
            {renderAllCheck()}
            <span className="media"></span>
            <span className="name"></span>
            <span className="counter"></span>
            <span className="price"></span>
            <div className="action"></div>
          </li>
        )
      )}
      {totalProductCount > 0 ? (
        data.map((company) => (
          <React.Fragment key={company.cmpnyNm}>
            <li className="companyName">
              <span>{company.cmpnyNm}</span>
            </li>
            {company.products.map((item) => (
              <li key={item.id}>
                <CustomCheckbox>
                  <input
                    type="checkbox"
                    checked={item.checked}
                    onChange={() =>
                      upsertCart({
                        ...item,
                        checked: !item.checked,
                      })
                    }
                  />
                  <span></span>
                </CustomCheckbox>
                <div
                  className="media"
                  onClick={() =>
                    navigateProduct({ cmpnyNo: company.cmpnyNo, id: item.vendorProductId })
                  }>
                  {renderImage(item)}
                </div>
                <div
                  className="name"
                  onClick={() =>
                    navigateProduct({ cmpnyNo: company.cmpnyNo, id: item.vendorProductId })
                  }>
                  <strong>{item.productName}</strong>
                  <span>
                    {item.options
                      .map(
                        (opt) =>
                          `${opt.name}${opt.price > 0 ? `(+${formatNumber(opt.price)}원)` : ""}`,
                      )
                      .join(" · ")}
                  </span>
                  <strong>{formatNumber(item.productPrice)}원</strong>
                </div>
                {isMobile ? (
                  <div className="box">
                    <span className="price">{formatNumber(calcPrice(item))}원</span>
                    {renderCounter(item)}
                  </div>
                ) : (
                  <>
                    {renderCounter(item)}
                    <span className="price">{formatNumber(calcPrice(item))}원</span>
                  </>
                )}
                <button
                  className="delete"
                  onClick={() =>
                    openModal({
                      isOpen: true,
                      type: "confirmation",
                      title: `상품 삭제`,
                      message: ["상품을 삭제하시겠습니까?"],
                      handleConfirm: () => deleteProduct([item.id]),
                      handleCancel: () => closeModal(),
                    })
                  }>
                  <IoClose />
                </button>
                {item.options.length > 0 && (
                  <button className="edit" onClick={() => setSelection(item)}>
                    옵션 변경
                  </button>
                )}
              </li>
            ))}
          </React.Fragment>
        ))
      ) : (
        <li className="not">장바구니 상품을 등록해주세요.</li>
      )}
    </ProductListContainer>
  );
};

export default ProductList;
